import angular from 'angular';
import PdfModalComponent from './pdf-modal.component';

const PdfModalModule = angular
    .module('control-room.commons.content.components.pdf-uploader.components.pdf-modal', [])
    .component('crPdfModal', PdfModalComponent);

export default PdfModalModule;
